export default class VoteForm {
  public value: number
  public votableId: number
  public votableType: 'Question' | 'Lesson' | 'Course' | 'Comment' | 'Comment' | 'Answer'
}
